<template>
    <span class="sp-marca" :class="'sp-marca--' + tamano">
        <img
            src="layout/images/seway-blanco.png"
            alt="Seway Plus"
            class="sp-marca__logo"
            width="180"
            height="56"
            :loading="perezoso ? 'lazy' : 'eager'"
            decoding="async"
        />

        <!-- Con texto el badge sobra: la propia línea ya dice "Negocios". -->
        <span v-if="mostrarBadge" class="sp-marca__badge">Negocios</span>

        <span v-if="conTexto" class="sp-marca__texto">
            <strong>Seway Plus Negocios</strong>
            <span>Publicidad para conductores en ruta</span>
        </span>
    </span>
</template>

<script>
/**
 * Bloque de marca de Seway Plus Negocios: logo oficial + badge "Negocios".
 *
 * Existe para que ese bloque se vea IGUAL en todas las pantallas del módulo.
 * Antes estaba duplicado en cuatro sitios con cuatro estilos distintos de badge
 * (degradado en el header, naranja plano en el login, translúcido con borde en
 * el pie) y con el logo dibujado a siete tamaños diferentes.
 *
 * No es interactivo a propósito: cada pantalla lo envuelve en el enlace o botón
 * que necesite (el header hace scroll al inicio, los pies enlazan a la landing).
 */
export default {
    name: 'MarcaNegocios',
    props: {
        /** sm = pies · md = drawer y móvil · lg = header y panel de acceso */
        tamano: {
            type: String,
            default: 'md',
            validator: (v) => ['sm', 'md', 'lg'].indexOf(v) !== -1
        },
        /** Muestra el nombre y la bajada al lado del logo (para los pies). */
        conTexto: { type: Boolean, default: false },
        /** Permite ocultar el badge en contextos donde estorbe. */
        badge: { type: Boolean, default: true },
        /** Carga diferida: activarlo cuando el logo esté bajo el pliegue. */
        perezoso: { type: Boolean, default: false }
    },
    computed: {
        mostrarBadge() {
            return this.badge && !this.conTexto;
        }
    }
};
</script>

<style lang="scss" scoped>
.sp-marca {
    display: inline-flex;
    align-items: center;
    gap: 0.6rem;
}

.sp-marca__logo {
    width: auto;
    flex: 0 0 auto;
}

/* Estilo único del badge, tomado del header (que es el que coincide con el
   mockup aprobado): degradado naranja, texto blanco y sombra suave. */
.sp-marca__badge {
    display: inline-block;
    flex: 0 0 auto;
    padding: 0.2rem 0.55rem;
    background: linear-gradient(135deg, var(--sp-orange) 0%, var(--sp-orange-400) 100%);
    border-radius: 6px;
    color: #fff;
    font-weight: 800;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    line-height: 1.5;
    box-shadow: 0 2px 8px rgba(235, 93, 27, 0.4);
}

.sp-marca__texto {
    display: flex;
    flex-direction: column;
    min-width: 0;
    text-align: left;

    strong {
        color: #fff;
        font-size: 0.92rem;
        font-weight: 700;
        line-height: 1.3;
    }

    > span {
        color: var(--sp-orange);
        font-size: 0.8rem;
        line-height: 1.35;
    }
}

/* ------------------------------ tamaños ------------------------------ */

.sp-marca--sm {
    .sp-marca__logo {
        height: 2.1rem;
    }

    .sp-marca__badge {
        padding: 0.15rem 0.45rem;
        font-size: 0.62rem;
    }
}

.sp-marca--md {
    .sp-marca__logo {
        height: 2.35rem;
    }

    .sp-marca__badge {
        font-size: 0.68rem;
    }
}

.sp-marca--lg {
    .sp-marca__logo {
        height: clamp(2.2rem, 3vw, 2.9rem);
    }

    .sp-marca__badge {
        font-size: 0.72rem;
    }
}
</style>
